import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket } from "@fortawesome/free-solid-svg-icons";
import missionImage from "../../common/images/mission.webp";
import visionImage from "../../common/images/vision.webp";
export default function Mission_Vission() {
  return (
    <section class="bg-white pt-8">
      <div class="container max-w-6xl 2xl:max-w-7xl  mx-auto">
        <div class="w-full mb-4">
          <div class="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
        </div>

        <div class="flex flex-wrap text-gray-800">
          <div class="w-full sm:w-1/2 my-auto px-6">
            <div className="justifiy-center">
              <h3 class="text-3xl text-gray-900 font-bold  text-center sm:text-left leading-none mb-2">
                Our Mission
              </h3>
              <div className=" flex w-full mb-8">
                <div className="flex mx-auto sm:mx-0">
                  <div className=" w-6 h-4 mr-1  rounded-full bg-green-600"></div>
                  <div className=" w-6 h-4 rounded-full  bg-blue-600"></div>
                </div>
              </div>
            </div>

            <div className="w-full flex">
              <span>
                <FontAwesomeIcon
                  className="text-green-600  mt-1 mr-2 text-xl"
                  icon={faRocket}
                />
              </span>
              <span className="text-gray-800 text-justify mb-3">
                Offer a well balanced environment for the members to learn, grow
                and excel in technical and it's related disciplines
              </span>
            </div>
            <div className="w-full flex">
              <span>
                <FontAwesomeIcon
                  className="text-green-600  mt-1 mr-2 text-xl"
                  icon={faRocket}
                />
              </span>
              <span className="text-gray-800 text-justify mb-3">
                Create a diversified culture of volunteering among the members
                as IEEE is a volunteer driven organisation
              </span>
            </div>
            <div className="w-full flex">
              <span>
                <FontAwesomeIcon
                  className="text-green-600  mt-1 mr-2 text-xl"
                  icon={faRocket}
                />
              </span>
              <span className="text-gray-800 text-justify mb-3">
                Prepare them to organize and implement events and projects
                aligning with IEEE recommendations
              </span>
            </div>
            <div className="w-full flex">
              <span>
                <FontAwesomeIcon
                  className="text-green-600  mt-1 mr-2 text-xl"
                  icon={faRocket}
                />
              </span>
              <span className="text-gray-800 text-justify mb-3">
                Get introduced to professional networking aspects of
                professionalism imbibing the essence of Code of Ethics of IEEE
              </span>
            </div>
          </div>
          <div class="w-full sm:w-1/2 my-auto px-6">
            <img className="w-full object-contain" alt="" src={missionImage} />
          </div>
        </div>

        <div class="flex flex-wrap flex-col-reverse sm:flex-row">
          <div class="w-full sm:w-1/2 ">
            <img
              className="h-48 object-contain mx-auto my-auto"
              alt=""
              src={visionImage}
            />
          </div>
          <div class="w-full sm:w-1/2 p-6 my-auto">
            <div class="align-middle">
              <div className="justifiy-center">
                <h3 class="text-3xl text-center sm:text-right text-gray-900 font-bold leading-none mb-2">
                  Our Vision
                </h3>
                <div className=" flex w-full mb-8">
                  <div className="flex mx-auto sm:mr-0">
                    <div className=" w-6 h-4 mr-1  rounded-full bg-blue-600"></div>
                    <div className=" w-6 h-4 rounded-full  bg-green-700"></div>
                  </div>
                </div>
              </div>
              <p class="text-gray-800 text-justify mb-8">
                Strives to be the platform for the young minds to explore and
                experiment the Technical innovations, Humanitarian approach and
                Managerial skillets through Volunteering
                <br />
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
